module.exports = __webpack_public_path__ + "static/media/SmartShop_2-320w.232f7fac.png";